import React from 'react';
import styled from 'styled-components';
import AccellorLoading from './AccellorLoading';

const StatusContainer = styled.div`
  padding: 20px;
  background: rgba(52, 152, 219, 0.1);
  border-radius: 8px;
  margin-bottom: 20px;
  color: #2c3e50;
  font-size: 14px;
`;

const LoaderContainer = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 15px;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  margin: 10px 0;
  overflow: hidden;
`;

const Progress = styled.div`
  width: ${props => (props.value / props.total) * 100}%;
  height: 100%;
  background: #3498db;
  transition: width 0.3s ease;
`;

const ProcessingStatus = ({ status, progress, extractionProgress }) => {
  const calculatePercentage = (current, total) => {
    if (!total || total === 0) return 0;
    return Math.min(Math.round((current / total) * 100), 100);
  };

  return (
    <StatusContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
        <LoaderContainer>
          <AccellorLoading size={40} />
        </LoaderContainer>
        <span style={{ fontWeight: 'bold' }}>{status}</span>
      </div>
      
      {progress?.total > 0 && (
        <div style={{ marginBottom: '15px' }}>
          <div style={{ marginBottom: '5px', display: 'flex', justifyContent: 'space-between' }}>
            <span>Processing pages:</span>
            <span>{progress.processed}/{progress.total} ({calculatePercentage(progress.processed, progress.total)}%)</span>
          </div>
          <ProgressBar>
            <Progress 
              value={progress.processed} 
              total={progress.total} 
            />
          </ProgressBar>
        </div>
      )}
      
      {extractionProgress?.total > 0 && (
        <div>
          <div style={{ marginBottom: '5px', display: 'flex', justifyContent: 'space-between' }}>
            <span>Extracting data:</span>
            <span>{extractionProgress.extracted}/{extractionProgress.total} chunks ({calculatePercentage(extractionProgress.extracted, extractionProgress.total)}%)</span>
          </div>
          <ProgressBar>
            <Progress 
              value={extractionProgress.extracted} 
              total={extractionProgress.total}
            />
          </ProgressBar>
        </div>
      )}
    </StatusContainer>
  );
};

export default ProcessingStatus; 